import React, { useEffect } from 'react'
import generalClasses from './Wizard.module.css'
import classes from './CheckoutStep.module.css'
import { SubscriptionCartItem } from '../../components/CartItem/CartItem'
import { Button, ButtonIcon } from '../../components/Button/Button'
import { ReactComponent as ForwardIcon } from '../../assets/icons/arrow-forward.svg'
import { convertToFormatted } from '../../util/functions'
import { useSelector, useDispatch } from 'react-redux'
import { cartSelectors } from '../Cart/cartSlice'
import {
    jumpToWizardStep,
    nextWizardStep,
    isWizardStepComplete,
} from './wizardLogic'
import moment from 'moment'
import {
    PaymentGatewayStatus,
    usePaymentGateway,
} from '../Cart/usePaymentGateway'
import { PaymentModes } from '../Cart/paymentLogic'
import { userActions } from '../../redux/userSlice'

const _formatDate = date => moment(date).format('MMM DD, YYYY')

const CheckoutStep = () => {
    const dispatch = useDispatch()

    const selectedPlan = useSelector(cartSelectors.selectedPlan)
    const cartItemDetails = useSelector(cartSelectors.cartItemDetails)
    let plan,
        planDuration = { start: null, end: null }

    plan = cartItemDetails[selectedPlan?.detailId] || {}
    const now = new Date()
    planDuration = {
        start: _formatDate(now),
        end: _formatDate(
            moment(now).add(1, plan?.cycle === 'Annually' ? 'year' : 'month')
        ),
    }

    const totalAmount = plan?.amount

    useEffect(() => {
        if (!selectedPlan || !plan) {
            jumpToWizardStep('select-plan')
        }
    }, [selectedPlan, plan])

    useEffect(() => {
        if (isWizardStepComplete('checkout')) {
            jumpToWizardStep('confirmation')
        }
    })

    const {
        validate,
        pay,
        processing,
        renderModal,
        status,
    } = usePaymentGateway({
        onSuccessfulPayment({ customer }) {
            dispatch(userActions.updateDetails({ userDetails: customer }))
            nextWizardStep()
        },
        mode: PaymentModes.Plan,
    })

    const purchasePlan = async () => {
        if (processing) return
        await validate()
    }

    useEffect(() => {
        if (status === PaymentGatewayStatus.ValidationSuccess) {
            pay()
        }
    }, [status])

    return (
        <div className={generalClasses.wizardContent}>
            <h3 className={classes.stepTitle}>You are purchasing</h3>
            <div className={classes.panes}>
                <div className={classes.cartItems}>
                    <SubscriptionCartItem
                        name={plan.title}
                        price={convertToFormatted(plan.amount, true, true)}
                        duration={planDuration}
                    />
                </div>
                <div className={classes.purchaseRegion}>
                    <div className={classes.priceBox}>
                        <h5 className={classes.priceBoxLabel}>Total Amount</h5>
                        <h3 className={classes.priceBoxAmount}>
                            {convertToFormatted(totalAmount, false, true)}
                        </h3>
                        <Button
                            block
                            disabled={processing}
                            onClick={purchasePlan}
                            className={classes.priceBoxAction}
                        >
                            Buy Now
                            <ButtonIcon icon={<ForwardIcon />} />
                        </Button>
                    </div>
                </div>
            </div>
            {renderModal()}
        </div>
    )
}

export default CheckoutStep
